import { PaginaNode } from '@gql/graphql'
import { CardGrid, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './AziendaHubTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const AziendaHubTemplate = (props: Props) => {
  const { pagina = undefined } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <CardGrid
          item={{
            spaceTop: 'md',
            children:
              pagina?.menuChildren?.map((x) => ({
                ...x,
                name: x.nome,
                image: x.previewImage,
                imageAlt: x.imageAlt,
              })) || [],
          }}
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default AziendaHubTemplate
